var _excluded = ["children", "visible", "fixedToRelative", "onClose", "classes", "id"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import { useUniqueID } from "@xo-union/react-unique-id";
import { IconButton } from "@xo-union/tk-component-icons";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "./styles.css";
var Snackbar = function Snackbar(_ref) {
  var children = _ref.children,
    visible = _ref.visible,
    fixedToRelative = _ref.fixedToRelative,
    onClose = _ref.onClose,
    classesProp = _ref.classes,
    idProp = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = useUniqueID(idProp);
  var classes = useClasses(styles, classesProp);
  var visibility = visible ? 'is-visible' : "is-not-visible";
  var visibleClass = classes[visibility];
  var dialogRole = visible ? 'alertdialog' : 'none';
  var role = visible ? 'alert' : 'none';
  var live = visible ? 'assertive' : 'off';
  var ariaHidden = !visible;
  var positionClass = fixedToRelative ? classes['fixed-to-relative'] : classes['fixed-to-page'];
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes['snackbar-wrapper'], " ").concat(positionClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.container, " ").concat(visibleClass),
    role: dialogRole,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    "aria-label": "Dismiss",
    "aria-controls": id,
    name: "close",
    size: "md"
  })), /*#__PURE__*/React.createElement("div", _extends({
    role: role,
    "aria-live": live,
    id: id,
    className: classes.children
  }, props), children)));
};
Snackbar.defaultProps = {
  fixedToRelative: false,
  visible: false
};
process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
  /**
   * Contents of snackbar
   */
  children: PropTypes.node,
  /**
   * Should the snackbar be visible
   */
  visible: PropTypes.bool,
  /**
   * Whether or not to position the snackbar within a relative.
   * This use is discouraged except for a few scenarios like the sidebar. This
   * is only supported if the parent container is at the bottom of the viewport.
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Called when the close button is clicked
   */
  onClose: PropTypes.func,
  /**
   * Class dependencies
   */
  classes: classesPropType(['children', 'close-button-container', 'container', 'fixed-to-relative', 'fixed-to-page', 'is-visible', 'is-not-visible', 'snackbar-wrapper']),
  /**
   * ID of the snackbar component
   */
  id: PropTypes.string
} : void 0;
export default Snackbar;